export const CALENDAR_VIEW_OPTIONS = {
  month: 'dayGridMonth',
  week: 'dayGridWeek',
  day: 'dayGridDay',
};

export const CALENDAR_VIEW_BUTTONS = [
  {
    value: CALENDAR_VIEW_OPTIONS.month,
    label: 'Month',
  },
  {
    value: CALENDAR_VIEW_OPTIONS.week,
    label: 'Week',
  },
  {
    value: CALENDAR_VIEW_OPTIONS.day,
    label: 'Day',
  },
];
